// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31JAH","label":"styles_label__3Njl5"};